import { render, staticRenderFns } from "./CreatePhaseStatusVerticalStep4.vue?vue&type=template&id=f948b44c&"
import script from "./CreatePhaseStatusVerticalStep4.vue?vue&type=script&lang=ts&"
export * from "./CreatePhaseStatusVerticalStep4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports